import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Grid, Stack, Typography, createTheme, useMediaQuery } from '@mui/material';
import './style.css';
import { datetimeFormatter } from '../../utils/datetimeFormatter';
import { isEmpty } from '../../utils/helper';

export const ReadOnlyProjectTimeLineDetails = observer(({ details }) => {
  const theme = createTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [formChildren, setFormChildren] = useState([]);

  const getData = (value) => {
    return isEmpty(value) ? '_' : value;
  };

  useEffect(() => {
    setFormChildren(details?.children ? JSON.parse(details?.children) : []);
  }, [details]);

  return (
    <Paper sx={{ px: '30px', py: '20px', pb: '40px' }}>
      <Stack spacing={4}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  Sign up Date
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  {details?.signUpDate
                    ? datetimeFormatter.formatDate(details?.signUpDate, datetimeFormatter.toLocal)
                    : '_'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  Soil Test Date
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  {details?.soilTestDate
                    ? datetimeFormatter.formatDate(details?.soilTestDate, datetimeFormatter.toLocal)
                    : '_'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  Total Station Date
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  {details?.totalStationDate
                    ? datetimeFormatter.formatDate(details?.totalStationDate, datetimeFormatter.toLocal)
                    : '_'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  Floor Plan Finalised Date
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  {details?.floorPlanFinalisedDate
                    ? datetimeFormatter.formatDate(details?.floorPlanFinalisedDate, datetimeFormatter.toLocal)
                    : '_'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  Elevation Finalised Date
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  {details?.elevationFinalisedDate
                    ? datetimeFormatter.formatDate(details?.elevationFinalisedDate, datetimeFormatter.toLocal)
                    : '_'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  Master File Finalised Date
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  {details?.masterFileFinalisedDate
                    ? datetimeFormatter.formatDate(details?.masterFileFinalisedDate, datetimeFormatter.toLocal)
                    : '_'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  Tentative Commencement Date
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '12px', fontWeight: '700' }} component="p">
                  {details?.tentativeCommencementDate
                    ? datetimeFormatter.formatDate(details?.tentativeCommencementDate, datetimeFormatter.toLocal)
                    : '_'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Stack>
    </Paper>
  );
});
